import { CPLAT_API_ROUTES, usePost } from '@/api';
import { ENTERED_BY_MARKET_NAME } from '@/constants/localstorage';
import { useRegisterToken } from '@/contexts/register-token';
import { ROUTES } from '@/routes';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useToast } from './V3/useToast';
import { useRef } from 'react';

export const useMarketRegisterToken = () => {
  const navigate = useNavigate();
  const { showToast } = useToast();
  const { naverToken, shopbyToken } = useRegisterToken();

  const [searchParmas] = useSearchParams();

  const enteredByMarketNameRef = useRef(localStorage.getItem(ENTERED_BY_MARKET_NAME));
  const mallId = localStorage.getItem('mallId') || '';

  const { mutateAsync: onSetNaverCommerceToken } = usePost(CPLAT_API_ROUTES.setNaverCommerceToken);
  const { mutateAsync: onSetImwebAuthorizationCode } = usePost(
    CPLAT_API_ROUTES.setImwebAuthorizationCode,
  );
  const { mutateAsync: onSetShopbyAuthorizationCode } = usePost(
    CPLAT_API_ROUTES.setShopbyAuthorizationCode,
  );
  const { mutateAsync: onSetCafe24AuthorizationCode } = usePost(
    CPLAT_API_ROUTES.setCafe24AuthorizationCode,
  );

  const onConnect = async (cplatToken: string) => {
    if (enteredByMarketNameRef.current === 'naver')
      await onSetNaverCommerceToken({
        CplatToken: cplatToken,
        NaverCommerceToken: naverToken,
      })
        .then((res) => {
          const { code, message } = res.data;
          localStorage.removeItem(ENTERED_BY_MARKET_NAME);
          if (code === '200') {
            //구독이 모두 끝나고 마무리 안내 페이지로 페이지 전환 (유저 닉네임과 함께, 메니저 초대 방식등 설명이 있는 페이지)
            navigate(ROUTES.startStoreGuide);
          } else {
            showToast('warning', message);
          }
        })
        .catch(() => {
          showToast('warning', '서버와 통신이 원활하지 않습니다.\n다시 시도해 주세요.');
        });
    else if (enteredByMarketNameRef.current === 'imweb') {
      const imwebCode = searchParmas.get('code') || '';
      onSetImwebAuthorizationCode({
        CplatToken: cplatToken,
        ImwebAuthorizationCode: imwebCode,
      }).then((res) => {
        const { code, message } = res.data;
        localStorage.removeItem(ENTERED_BY_MARKET_NAME);
        if (code === '200') {
          navigate(ROUTES.intro);
        } else {
          showToast('warning', message);
        }
      });
    } else if (enteredByMarketNameRef.current === 'cafe24') {
      const cafe24AuthorizationCode = searchParmas.get('code') || '';

      onSetCafe24AuthorizationCode({
        cplatToken: cplatToken,
        authorizationCode: cafe24AuthorizationCode,
        mallId,
      }).then((res) => {
        const { code, message } = res.data;
        localStorage.removeItem(ENTERED_BY_MARKET_NAME);
        if (code === '200') {
          navigate(ROUTES.intro);
        } else showToast('warning', message);
      });
    } else if (enteredByMarketNameRef.current === 'shopby') {
      onSetShopbyAuthorizationCode({
        cplatToken: cplatToken,
        shopbyAuthorizationCode: shopbyToken,
      }).then((res) => {
        const { code, message } = res.data;
        localStorage.removeItem(ENTERED_BY_MARKET_NAME);
        if (code === '200') {
          navigate(ROUTES.intro);
        } else showToast('warning', message);
      });
    }
  };

  return { onConnect };
};
